import axiosClient, { HUB_ACCESS_TOKEN_KEY } from './axiosClient';
import type { User } from '../types';

export async function signIn(email: string, password: string) {
  try {
    const response = await axiosClient.post<{ accessToken: string; user: User }>(
      '/auth/login',
      { email, password }
    );
    sessionStorage.setItem(HUB_ACCESS_TOKEN_KEY, response.data.accessToken);
    return {
      isOk: true,
      data: response.data.user
    };
  }
  catch (error: any) {
    return {
      isOk: false,
      message: error?.response?.data?.message ?? "Não foi possível autenticar."
    };
  }
}

export async function getUser() {
  if (!sessionStorage.getItem(HUB_ACCESS_TOKEN_KEY)) {
    return { isOk: false };
  }
  try {
    const response = await axiosClient.get<User>('/auth/me');
    return {
      isOk: true,
      data: response.data
    };
  }
  catch {
    sessionStorage.removeItem(HUB_ACCESS_TOKEN_KEY);
    return {
      isOk: false
    };
  }
}

export async function createAccount(email: string, password: string) {
  void email;
  void password;
  return { isOk: false, message: "Cadastro de usuários disponível apenas para administradores." };
}

export async function changePassword(email: string, recoveryCode?: string) {
  void email;
  void recoveryCode;
  return { isOk: false, message: "Recuperação de senha ainda não disponível." };
}

export async function resetPassword(email: string) {
  void email;
  return { isOk: false, message: "Recuperação de senha ainda não disponível." };
}
